<template>
	<div>
		<vAlert
			theme="info"
		>Container receiving time of  warehouse: Monday~Friday AM 8:30~PM 2:00. Accept drop unload.Or please contact Account Manager for liveunload.</vAlert>
		<compWrapper title="Basic Information" theme="primary">
			<compFormEdit
				:labelWidth="160"
				ref="formbase"
				class="margin-15"
				:formdata="getBase"
				v-model="formData"
			></compFormEdit>
		</compWrapper>
		<compWrapper title="Inbound Information" theme="primary">
			<compFormEdit
				:labelWidth="160"
				ref="forminfo"
				class="margin-15"
				:formdata="getWareInfo"
				v-model="formData"
			></compFormEdit>
			<template slot="footer">
				<template v-for="(item,index) in getAuthList">
					<vButton
						v-if="item.show"
						:key="index"
						class="margin-right-15"
						:theme="item.theme"
                        :disabled="item.disabled"
						@click="item.operate"
					>{{item.label}}</vButton>
				</template>
				<vButton class="margin-right-15" @click="cancel">Return</vButton>
			</template>
		</compWrapper>
        <!-- 全局弹框 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-confirm="modalProps={}"
            @on-close="modalProps={}"
		>
            <component ref="cusref" :is="modalProps.component"  v-bind="modalProps" @on-close="modalProps={}" v-on="modalProps.on"></component>
        </compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import compAlertCalendar from "./reservation/alertcalendar.vue"
// import { mapState, mapGetters } from 'vuex';
import { HttpBespeak, HttpUpdateBespeak, HttpCheckContainerNo, HttpGetOrderInfo, HttpSaveBespeak, HttpSubmitBespeak, HttpEditSubBespeak, HttpBespeakByContainerNo } from '@/service/bespeak';
export default {
    components: {
        compAlertCalendar,
	},
	data() {
		return {
			loading: false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			orgRoleName: this.$route.query.orgRoleName,
			calculateList: [],
			formData: {
				goodTypeCode: "FCL",
				goodTypeName: "FCL(Container)",
				reserveBy: "Inbound Plan No.",
                reserveHour:'0',
                startTime:'09:00:00',
                endTime:'14:00:00'
			},
            modalProps:{},
            showzengzhi:true,
            flag:0,
		}
	},
	created() {
		this.getDetail();
	},
	computed: {
		getAuthList() {
			const type = this.type,
				agent = this.orgRoleName === 'FORWARDER',
				custom = this.orgRoleName === 'MERCHANT',
				manage = this.orgRoleName === 'WAREHOUSE';
			return [
            //     {
			// 	label: 'Save&New',
			// 	operate: this.saveNextBespeak,
			// 	show: type === 'add' && (agent || custom),
			// 	theme: "primary"
			// }, 
            {
				label: 'Save',
				operate: this.saveBespeak,
				show: type === 'add' && (agent || custom),
				theme: "success",
                disabled:this.flag>0,
			}, {
				label: 'Save',
				operate: this.updateBespeak,
				show: type === 'edit' && (agent || custom),
				theme: "error",
                disabled:this.flag>0,
			}, {
				label: 'Submit',
				operate: this.submitBespeak,
				show: true,
				theme: "info",
                disabled:this.flag>0,
			}]
		},
		getStatusMap() {
			return {
				'0': 'Draft',
				'1': 'Pending',
				'2': 'Approved',
				'3': 'Rejected',
				'4': 'Unloaded',
				'5': 'Cancelled',
                '6': 'Arrived',
			}
		},
		getBase() {
			const { warehouseTitle = '', orgWarehouseCode = '', inboundType = '', status = 0 } = this.formData,
				isEdit = this.type === 'edit';
                const orderid = this.id
			return [
            {
                label: 'Plan No/Container No',
                key: 'orderNo',
                props: {
                    // placeholder: "Multiple numbers seperated by ','"
                },
                // formItem: {
                //     rules: {
                //         required: true,
                //         // message: "该信息不能为空,请填写",
                //         validator: (rule, value, callback) => {
                //             if (!value || !/^[A-Z]{4}\d{7}$/g.test(value)) {
                //                 callback('This information cannot be blank or in incorrect format. Please fill it in again.');
                //             } else {
                //                 // console.log(value, 'value')
                //                 //根据箱号查询预约单是否可用
                //                 let formData = isEdit ? { reserveInboundId: orderid, containerNo: value } : { containerNo: value }
                //                 return HttpCheckContainerNo(formData).then(res => {
                //                     this.getBespeakList(value);
                //                     callback();
                //                 }, err => {
                //                     callback(err.message)
                //                 });
                //             }
                //         },
                //     },
                // },
                on: {
                    'on-blur': this.getBespeakInfo
                }
            }, 
            this.getCargoform,
            {
				label: 'Container No.',
				key: 'containerNo',
				query: true,
			}, 
            // 新增日历插件的地方
            {
				label: 'Delivery Time',
				key: 'clientRequestDate',
                props:{
                    placeholder:'Please select a date',
                    readonly:true,
                },
                children: (h) => {
                    return <vIcon
                        type='search'
                        slot='suffix'
                        size='18'
                        class='margin-right-5'
                        nativeOnClick={this.handleTemplateModal}
                    />
                },
                span:this.type!='query' ? 6 : 12,
			},
            {
				labelWidth:0,
                tag:'vSelect',
                key: 'reserveHour',
                options: [
                    {label:"09:00:00-14:00:00",value:'0'},
                ],
                props:{
                    readonly:true,
                },
                // on:{
                //     'on-change':(val)=>{
                //         // 时间段赋值
                //         if(val == 0){
                //             this.formData.startTime = '09:00:00';
                //             this.formData.endTime = '14:00:00';
                //         }else{
                //             this.formData.startTime = '12:00:00';
                //             this.formData.endTime = '14:00:00';
                //         }
                //     }
                // },
                span:this.type!='query' ? 6 : 0,
			},
             {
				label: 'Inbound Plan No.',
				key: 'inboundNos',
				query: true,
			}, 
            // 选择增值的展示 
            // 非查看页面
            {
				label: 'Second Delivery Time',
				key: 'secondClientRequestDate',
                span:this.formData.bookingType == 0 && this.type !='query'&&this.formData.secondClientRequestDate ? 6 : 0,
                props:{
                    readonly:true,
                }
				// query: true,
			},{
				labelWidth:0,
                valueText:this.formData.startTime+'-'+this.formData.endTime,
                span:this.formData.bookingType == 0 && this.type !='query'&&this.formData.secondClientRequestDate ? 6 : 0,
                props:{
                    readonly:true,
                    value:this.formData.startTime+'-'+this.formData.endTime
                }
                // query:true,
			}, 
            {
				label: 'Reservation No.',
				key: 'reserveInboundNo',
				show: isEdit,
				query: true,
			}, {
				label: 'Status',
				valueText: this.getStatusMap[status],
				show: isEdit,
				query: true,

			},
            {
				label: 'Warehouse',
				key: 'warehouseTitle',
				query: true,
				valueText: warehouseTitle ? `${warehouseTitle}(${orgWarehouseCode})` : ''
			}, {
				label: 'Inbound Type',
				key: 'inboundType',
				valueText: inboundType == 1 ? 'Transfer' : 'Purchase',
				query: true,

			}, {
				label: 'Project',
				key: 'lineNames',
				query: true,
			}, {
				label: 'Remark',
				tag: 'vTextarea',
				key: 'remark',
				required: false,
			},{
				label: 'Shipment ID',
				key: 'shipmentId',
                query: true,
			}, {
				label: 'CC',
				key: 'carbonCopy',
				props: {
					placeholder: "Multiple emails seperate by ';'"
				},
				required: false,
			}
            ]
		},
		getWareInfo() {
			const { goodTypeCode } = this.formData;
			if (goodTypeCode === 'LTL') return this.getWareLitInfo
			if (goodTypeCode === 'Express') return this.getWareExpressInfo
			return this.getWareFclInfo
		},
		getCargoform() {
			return {
				label: 'Cargo Form',
				tag: 'vSelect',
				key: 'goodTypeCode',
				on: {
					'on-attach': (attach, val) => {
						this.formData.goodTypeName = attach.label;
					}
				},
				options: [
					{
						label: 'FCL(Container)',
						value: 'FCL'
					},
					{
						label: 'LTL(Truck)',
						value: 'LTL',
					},
					// {
					// 	label: 'Express',
					// 	value: 'Express'
					// }
				]
			}
		},
		getWareFclInfo() {
            const isEdit = this.type === 'edit';
            const orderid = this.id
			return [
				{
					label: 'Container Type',
					tag: 'vSelect',
					key: 'containerType',
					options: [
						{
							label: '20GP',
							value: 1
						},
						{
							label: '40GP',
							value: 2,
						},
						{
							label: '40HQ',
							value: 3
						},
						{
							label: '45HQ',
							value: 4
						}
					]
				}, {
					label: 'Container No.',
					key: 'containerNo',
					props: {
						placeholder: "4 capital letters & 7 digits"
					},
					formItem: {
						rules: {
							required: true,
							// message: "该信息不能为空,请填写",
							validator(rule, value, callback) {
								if (!value || !/^[A-Z]{4}\d{7}$/g.test(value)) {
									callback('This information cannot be blank or in incorrect format. Please fill it in again.');
								} else {
									// console.log(value, 'value')
									//根据箱号查询预约单是否可用
									let formData = isEdit ? { reserveInboundId: orderid, containerNo: value } : { containerNo: value }
									return HttpCheckContainerNo(formData).then(res => {
										callback();
									}, err => {
										callback(err.message)
									});
								}
							},
						},
					}
				}, {
					label: 'Port Arrived Date',
					tag: "vDatepicker",
					props: {
						format: "yyyy-mm-dd"
					},
					key: 'arriveDate'
				}, {
					label: 'LFD of demurrage',
					tag: "vDatepicker",
					key: 'lfdDemurrage',
					props: {
						format: "yyyy-mm-dd"
					}
				}, {
					label: 'LFD of detention',
					tag: "vDatepicker",
					key: 'lfdDetention',
					props: {
						format: "yyyy-mm-dd"
					}
				},
				// {
				// 	label: 'Client Request Date',
				// 	tag: "vDatepicker",
				// 	key: 'clientRequestDate',
				// 	props: {
				// 		format: "yyyy-mm-dd"
				// 	},
				// 	required: false,
				// },
				{
					label: 'Carton QTY',
					tag: "vInputNumber",
					key: 'totalCartonCount',
					required: false,
					props: {
						precision: 0,
						min: 0,
					}
				}, {
					label: 'Volume(CBM)',
					tag: "vInputNumber",
					key: 'totalVolume',
					required: false,
					props: {
						min: 0,
					}
				}, {
					label: 'Truck Company',
					key: 'truckCompany',
					required: false,
				}, {
					label: 'License Plate No.',
					key: 'plateNo',
					required: false,
				}
			];
		},
		getWareLitInfo() {
			return [
				this.getCargoform,
				{
					label: 'Pallet QTY',
					key: 'trayCount',
					tag: "vInputNumber",
					props: {
						precision: 0,
						min: 0,
					}
				}, {
					label: 'BOL',
					key: 'bol',
					required: false,
				}, {
					label: 'Carton QTY',
					key: 'totalCartonCount',
					required: false,
					tag: "vInputNumber",
					props: {
						precision: 0,
						min: 0,
					}
				}, {
					label: 'Volume(CBM)',
					key: 'totalVolume',
					required: false,
					tag: "vInputNumber",
					props: {
						min: 0,
					},

				}, {
					label: 'Truck Company',
					key: 'truckCompany',
					required: false,
				}, {
					label: 'License Plate No.',
					key: 'plateNo',
					required: false,
				},
				{
					label: 'Client Request Date',
					tag: "vDatepicker",
					key: 'clientRequestDate',
					props: {
						format: "yyyy-mm-dd"
					},
					required: false,
				},
			];
		},
		getWareExpressInfo() {
			return [
				this.getCargoform, {
					label: 'Express Company',
					key: 'courierCompany'
				}, {
					label: 'Tracking',
					key: 'tracking'
				},
				{
					label: 'Client Request Date',
					tag: "vDatepicker",
					key: 'clientRequestDate',
					props: {
						format: "yyyy-mm-dd"
					},
					required: false,
				},
			];
		},
	},
	methods: {
        handleTemplateModal(){
            if(!this.formData.orgWarehouseId){
                this.$Message.error('Please fill in the slip number first！');
                return;
            }
            this.modalProps = {
                show: true,
                title: 'Value-added reservation display',
                showFooter: false,
                width: 600,
                component: 'compAlertCalendar',
                type: this.type,
                id: this.id,
                bookingType:this.formData.bookingType,
                orgWarehouseId:this.formData.orgWarehouseId,
                goodTypeCode:this.formData.goodTypeCode,
                on:{
                    'on-update':(val)=>{
                        if(val.bookingType == 1){
                            // this.formData.bookingType = val.bookingType;
                            // this.formData.clientRequestDate = val.clientRequestDate;
                            this.$set(this.formData,'bookingType',val.bookingType);
                            this.$set(this.formData,'clientRequestDate',val.clientRequestDate);
                        }else{
                            // this.formData.bookingType = val.bookingType;
                            // this.formData.clientRequestDate = val.clientRequestDate;
                            // this.formData.secondClientRequestDate  = val.secondClientRequestDate
                            this.$set(this.formData,'bookingType',val.bookingType);
                            this.$set(this.formData,'clientRequestDate',val.clientRequestDate);
                            this.$set(this.formData,'secondClientRequestDate',val.secondClientRequestDate);
                        }

                    }
                }
            }
        },
		cancel() {
			this.$router.push({ name: this.$route.name.slice(0, -6) })
		},
		hanleNextBespeak() {
			const { lineNames, warehouseTitle, orgWarehouseCode, orgWarehouseId, inboundType, inboundNos, remark } = this.formData;
			this.formData = { lineNames, warehouseTitle, orgWarehouseCode, orgWarehouseId, inboundType, inboundNos, remark };
			this.$refs.forminfo.resetValidate();
		},
		async updateBespeak() {
            
			const valid = await Promise.all([this.$refs.formbase.validate(), this.$refs.forminfo.validate()]);
			if (!valid) return;
            this.flag = 1;
			this.loading = true;
			HttpUpdateBespeak({ ...this.formData, orgRoleName: this.orgRoleName }).then(res => {
				this.cancel();
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		// async saveNextBespeak() {
		// 	this.saveBespeak(true)
		// },
		async saveBespeak(isNext) {
			const valid = await Promise.all([this.$refs.formbase.validate(), this.$refs.forminfo.validate()]);
			if (!valid) return;
            this.flag = 1;
			this.loading = true;
			HttpSaveBespeak({ ...this.formData, orgRoleName: this.orgRoleName }).then(res => {
				if (isNext !== true) return this.cancel();
				this.loading = false;
				this.hanleNextBespeak();
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		async submitBespeak() {
			const valid = await Promise.all([this.$refs.formbase.validate(), this.$refs.forminfo.validate()]);
			if (!valid) return;
            this.flag = 1;
			this.loading = true;
            if(this.type === 'edit'){
                HttpEditSubBespeak({...this.formData, orgRoleName: this.orgRoleName}).then(res => {
                    this.cancel();
                }, err => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                })
            }else{
                HttpSubmitBespeak({...this.formData, orgRoleName: this.orgRoleName}).then(res => {
                    this.cancel();
                }, err => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                })
            }
			// const request = this.type === 'edit' ? HttpEditSubBespeak : HttpSubmitBespeak;
			// request({ ...this.formData, orgRoleName: this.orgRoleName }).then(res => {
			// 	this.cancel();
			// }, err => {
			// 	this.loading = false;
			// 	this.$VMessage.error(err.message);
			// })
		},
		async getDetail() {
			if (this.type === 'add') return;
			this.loading = true;
			HttpBespeak({
				id: this.id,
				orgRoleName: this.orgRoleName
			}).then(res => {
				const data = res.data || {};
				this.formData = data;
                if(this.formData.startTime == '09:00:00' || this.formData.startTime  == ''){
                    this.formData.reserveHour = 0;
                    this.formData.startTime = '09:00:00';
                    this.formData.endTime = '14:00:00';
                }
                this.formData.orderNo = res.data.reserveInboundNo;
				this.loading = false;
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			});
		},
		//查找预约单号
		async getBespeakInfo(val) {
			if (!val) return;
			HttpGetOrderInfo({
				orderNosStr: val,
				orgRoleName: this.orgRoleName,
                reserveInboundId:this.id,
			}).then(res => {
				const { lineNames, warehouseTitle, orgWarehouseCode, orgWarehouseId, inboundType, shipmentId,containerNo,containerType,inboundNos } = res.data;
				this.formData = { ...this.formData, lineNames, warehouseTitle, orgWarehouseCode, orgWarehouseId, inboundType, shipmentId,containerNo,containerType,inboundNos };
			}, err => {
				this.formData = this.type === 'edit' ? { ...this.formData, inboundNos: '' } : {};
				this.$VMessage.error(err.message);
			});
		},
		//查找预约单号列表
		async getBespeakList(val) {
			if (!val) return;
			HttpBespeakByContainerNo({
				'containerNo': val,
				'orgRoleName': this.orgRoleName
			}).then(res => {
				const {
					lineNames,
					warehouseTitle,
					orgWarehouseCode,
					orgWarehouseId,
					inboundType,
					containerType,
					goodTypeCode,
					inboundNos,
				} = res.data;
				this.formData = {
					...this.formData,
					lineNames,
					warehouseTitle,
					orgWarehouseCode,
					orgWarehouseId,
					inboundType,
					containerType,
					goodTypeCode,
					inboundNos,
				};
                
			}, err => {
				this.formData.inboundNos = '';
				this.$VMessage.error(err.message);
			});
		},


	}
};
</script>
